/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EyeOpenIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "eye-open", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M12.5 7.5C8.5 7.5 6 10 4.5 12.5C6 15 8.5 17.5 12.5 17.5C16.5 17.5 19 15 20.5 12.5C19 10 16.5 7.5 12.5 7.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 2.5, fill: "currentColor", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(EyeOpenIcon);
export default ForwardRef;
//# sourceMappingURL=eyeOpenIcon.js.map